import withStyles from '@material-ui/core/styles/withStyles';
import { default as React } from 'react';
import { connect } from 'react-redux';
import * as Score from "utils/Score";
import { ratingBuckets, positivePercent, focusSelection, DistributionBar, RatingLegend, ScoreChip, CompareBars, deltaText, MONO } from "./ReportViz";
import pdf from "utils/pdfKit";
import { downloadXlsx } from "utils/xlsx";
import moment from "moment";

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-normal.js')
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-bold.js')
const styles = {};
const report_types = [
    {
        label: t('Analytical'),
        value: "Analytical"
    },
    {
        label: t('Summary'),
        value: "Summary"
    },
    {
        label: t('Text reports'),
        value: "Textreports"
    },
    {
        label: t('Comparation'),
        value: "Comparation"
    }
];
class Analytical extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData: this.props.filterData,
            surveyQuestion: this.props.surveyQuestion,
            surveyResponses: this.props.surveyResponses,
            surveyMain: this.props.surveyMain,
            reportData: null,
            reportData2: null,
            compare: false
        }
    }

    componentDidMount() {
        this.props.onRef(this)
        this.initData()
    }
    initData = () => {
        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props
        const compare = !!this.props.compare
        const data = this.calculateData(surveyQuestion, surveyResponses)
        const data2 = (compare && this.props.surveyResponses2)
            ? this.calculateData(surveyQuestion, this.props.surveyResponses2)
            : null
        this.setState({

            filterData: filterData,
            surveyQuestion: surveyQuestion,
            surveyResponses: surveyResponses,
            surveyMain: surveyMain,
            reportData: data,
            reportData2: data2,
            compare: compare
        })
    }
    calculateSummaryData = (filterQuestion, filterResponses) => {
        let reportSections = [];
        let surveyScore = 0
        let totalResult = null
        if (filterQuestion.sections.length > 0) {

            let countSectionScore = 0
            filterQuestion.sections.map((section) => {
                let reportQuestions = []
                let sectionScore = 0
                if (section.questions.length > 0) {
                    let countQuestionScore = 0
                    section.questions.map((q) => {
                        if (Score.VALUETYPE !== q.question.type) return null;
                        const reportOfQuestion = Score.getReportOfQuestion(q, filterResponses);
                        reportOfQuestion.q = q;
                        reportQuestions.push(reportOfQuestion)
                        if (reportOfQuestion.questionScore > 0) {
                            countQuestionScore++;
                            sectionScore += reportOfQuestion.questionScore
                        }
                    })
                    sectionScore = countQuestionScore > 0 ? (sectionScore / countQuestionScore) : 0
                }
                const reportsForSection = {
                    sectionTitle: section.sectionTitle,
                    reportQuestions,
                    sectionScore
                }
                reportSections.push(reportsForSection)
                if (reportsForSection.sectionScore > 0) {
                    countSectionScore++
                    surveyScore += reportsForSection.sectionScore
                }
            })
            totalResult = {
                reportSections: reportSections,
                surveyScore: countSectionScore > 0 ? (surveyScore / countSectionScore) : 0
            }
        }
        return totalResult
    }
    addDocText(doc, text, x, y) {
        const docWidth = doc.internal.pageSize.getWidth();

        var line = y // Line height to start text at
        var lineHeight = 4
        var leftMargin = x
        var wrapWidth = docWidth - 2 * x

        var splitText = doc.splitTextToSize(text, wrapWidth)
        for (var i = 0, length = splitText.length; i < length; i++) {
            // loop thru each line and increase
            doc.text(splitText[i], leftMargin, line)
            line = lineHeight + line
        }
        return line
    }
    generatePdf = (fileName) => {
        const doc = new jsPDF();
        const W = doc.internal.pageSize.getWidth();
        const H = doc.internal.pageSize.getHeight();
        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props

        const doCompare = !!(this.props.compare && this.props.surveyResponses2)
        const data = this.calculateData(surveyQuestion, surveyResponses)
        const data2 = doCompare ? this.calculateData(surveyQuestion, this.props.surveyResponses2) : null
        const summaryData = this.calculateSummaryData(surveyQuestion, surveyResponses)
        const summaryData2 = doCompare ? this.calculateSummaryData(surveyQuestion, this.props.surveyResponses2) : null

        // Widest rating scale in use (score denominator + colour mapping).
        let scale = 5
        data.reportSections.forEach(sec => sec.reportQuestions.forEach(rq => {
            if (rq.q && rq.q.question && rq.q.question.type === 'radio') { const mv = ratingBuckets(rq.q, rq.reports).maxV; if (mv > scale) scale = mv }
        }))

        // Header band + subtitle.
        const period1 = moment(filterData.from1).format('LL') + ' – ' + moment(filterData.to1).format('LL')
        const period2 = moment(filterData.from2).format('LL') + ' – ' + moment(filterData.to2).format('LL')
        const subtitle = period1 + (doCompare ? '  ·  vs ' + period2 : '') + '   ·   ' + surveyResponses.length + ' ' + t('Answers')
        let y = pdf.header(doc, { title: surveyMain.title, subtitle, right: t('Analytical') })

        // Active filters caption.
        const flt = []
        if (filterData.group.length) flt.push(t('Emails Group') + ': ' + filterData.group.map(a => a.label).join(', '))
        if (filterData.section) flt.push(t('Section') + ': ' + filterData.section.label)
        if (filterData.question) flt.push(t('Question') + ': ' + filterData.question.label)
        if (filterData.answer.length) flt.push(t('Answers') + ': ' + filterData.answer.map(a => a.label).join(', '))
        if (flt.length) {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8); doc.setTextColor(pdf.FAINT[0], pdf.FAINT[1], pdf.FAINT[2]);
            doc.text(flt.join('    |    '), 12, y, { maxWidth: W - 24 }); y += 6;
        }

        // Focus on the filter-selected section/question, exactly like the on-screen report.
        const focus = focusSelection(data.reportSections, surveyQuestion, filterData)
        const summarySecs = focus.indices.map(i => summaryData.reportSections[i])
        const summarySecs2 = doCompare ? focus.indices.map(i => summaryData2.reportSections[i]) : null
        if (focus.focused) {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8); doc.setTextColor(pdf.GREEN[0], pdf.GREEN[1], pdf.GREEN[2]);
            doc.text('🔎 ' + t('Focused view') + ': ' + focus.sectionTitle + (focus.questionTitle ? ' › ' + focus.questionTitle : ''), 12, y, { maxWidth: W - 24 }); y += 6;
        }

        // Section averages (A/B/Δ when comparing), colour-coded.
        const sScore = (v) => ({ content: v.toFixed(2), styles: { textColor: pdf.scoreColor(v, scale), fontStyle: 'bold', halign: 'right' } })
        let head, body
        if (doCompare) {
            head = [[t('Section Average with Rating'), 'A', 'B', 'Δ']]; body = []
            summarySecs.forEach((s, i) => {
                if (!s || s.sectionScore <= 0) return
                const s2 = summarySecs2[i]; const a = s.sectionScore, b = s2 ? s2.sectionScore : 0, d = a - b
                body.push([s.sectionTitle, sScore(a), sScore(b),
                    { content: (d >= 0 ? '+' : '') + d.toFixed(2), styles: { textColor: pdf.deltaColor(d), fontStyle: 'bold', halign: 'right' } }])
            })
        } else {
            head = [[t('Section Average with Rating'), t('Score')]]; body = []
            summarySecs.forEach(s => { if (s && s.sectionScore > 0) body.push([s.sectionTitle, sScore(s.sectionScore)]) })
        }
        doc.autoTable(pdf.modernOptions({ startY: y, head, body }))
        y = doc.previousAutoTable.finalY + 8

        // Per-question distribution bars (the on-screen look), single or A-over-B.
        const bottom = H - 16
        const ensure = (need) => { if (y + need > bottom) { doc.addPage(); pdf.topStrip(doc); y = 16; } }
        const segsOf = (rq) => {
            const b = ratingBuckets(rq.q, rq.reports)
            return { b, segs: b.buckets.filter(x => x.count > 0).map(x => ({ pct: x.pct, color: pdf.parseRgb(x.color), label: x.pct >= 12 ? String(x.count) : '' })) }
        }
        const drawBar = (x, yy, w, h, segs) => {
            doc.setFillColor(240, 243, 241); doc.rect(x, yy, w, h, 'F')
            let cx = x
            segs.forEach(s => {
                const sw = w * s.pct / 100; if (sw <= 0) return
                doc.setFillColor(s.color[0], s.color[1], s.color[2]); doc.rect(cx, yy, sw, h, 'F')
                if (sw > 8 && s.label) { doc.setTextColor(255, 255, 255); doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(6); doc.text(s.label, cx + sw / 2, yy + h / 2 + 1.6, { align: 'center' }) }
                cx += sw
            })
        }
        // Colour legend under EVERY bar so every colour has a readable label — and, for a single
        // period, its count (%) too, so even segments too thin to hold a number are legible.
        // (In compare, A and B counts differ, so labels only — like the on-screen legend.)
        const legendItems = (buckets, withCount) => buckets.map(x => ({
            text: withCount ? String(x.label || '') + ': ' + x.count + ' (' + Math.round(x.pct) + '%)' : String(x.label || ''),
            color: x.color,
        }))
        const legItemW = (it) => 2.4 + 2 + doc.getTextWidth(it.text) + 6
        const legendHeight = (items, w) => {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(6.5)
            let cx = 0, lines = 1
            items.forEach(it => { const iw = legItemW(it); if (cx + iw > w) { cx = 0; lines++ } cx += iw })
            return lines * 4.4 + 1.5
        }
        const drawLegend = (x, y0, w, items) => {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(6.5)
            let cx = x, cy = y0 + 2.5, lineH = 4.4
            items.forEach(it => {
                const iw = legItemW(it)
                if (cx + iw > x + w) { cx = x; cy += lineH }
                const c = pdf.parseRgb(it.color)
                doc.setFillColor(c[0], c[1], c[2]); doc.rect(cx, cy - 2.4, 2.4, 2.4, 'F')
                doc.setTextColor(pdf.SOFT[0], pdf.SOFT[1], pdf.SOFT[2]); doc.text(it.text, cx + 4.4, cy)
                cx += iw
            })
            return (cy - y0) + lineH
        }
        // n=0 questions show a note instead of an empty bar (matches the on-screen "No answers").
        const emptyNote = (x, yy) => {
            doc.setTextColor(pdf.FAINT[0], pdf.FAINT[1], pdf.FAINT[2]); doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(7.5)
            doc.text(t('No answers'), x, yy + 3.5)
        }

        focus.sections.forEach((section, si) => {
            if (!section.reportQuestions.length) return
            const origIdx = focus.indices[si]
            ensure(11)
            doc.setFillColor(pdf.SEC_FILL[0], pdf.SEC_FILL[1], pdf.SEC_FILL[2]); doc.rect(12, y, W - 24, 7, 'F')
            doc.setTextColor(pdf.GREEN[0], pdf.GREEN[1], pdf.GREEN[2]); doc.setFont('DejaVuSans', 'bold'); doc.setFontSize(9)
            doc.text(section.sectionTitle, 14, y + 4.8, { maxWidth: W - 50 })
            if (section.sectionScore > 0) { const c = pdf.scoreColor(section.sectionScore, scale); doc.setTextColor(c[0], c[1], c[2]); doc.text(section.sectionScore.toFixed(2) + ' / ' + scale, W - 14, y + 4.8, { align: 'right' }) }
            y += 10

            const section2 = doCompare && data2 ? data2.reportSections[origIdx] : null
            const barX = 14, barH = 5.5
            section.reportQuestions.forEach((rq, qi) => {
                const { b, segs } = segsOf(rq)
                const rq2 = section2 ? (section2.reportQuestions.find(x => x.q && rq.q && x.q.id === rq.q.id) || null) : null
                const cmp = doCompare && rq2

                // Wrap the (possibly long) question title so a 2nd line never runs under the bar.
                doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8.5)
                const titleLines = doc.splitTextToSize(rq.questionTitle, W - 78)
                const titleH = titleLines.length * 4.0

                // Legend under every bar: count(%) for a single period, labels only in compare.
                const lb = cmp ? b.buckets : b.buckets.filter(x => x.count > 0)
                const legItems = lb.length ? legendItems(lb, !cmp) : []
                const showLeg = legItems.length && (b.total > 0 || cmp)
                const legH = showLeg ? legendHeight(legItems, W - 28) : 0
                const barsH = cmp ? (barH * 2 + 4.6) : (barH + 3)
                ensure(3 + titleH + 1.5 + barsH + legH + 3)

                // Title (multi-line) + meta on the first line.
                doc.setTextColor(pdf.INK[0], pdf.INK[1], pdf.INK[2]); doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8.5)
                doc.text(titleLines, 14, y + 3)
                let meta
                if (cmp) meta = 'A ' + rq.questionScore.toFixed(2) + '   B ' + rq2.questionScore.toFixed(2)
                else { const pos = positivePercent(rq.q, rq.reports); const un = rq.totalResponses != null ? rq.totalResponses - rq.answeredCount : 0; meta = 'n=' + b.total + (un > 0 ? '   ' + un + ' ' + t('without answer') : '') + (pos != null ? '   ' + pos + '% ' + t('positive') : '') + (b.rating && rq.questionScore > 0 ? '   ' + rq.questionScore.toFixed(2) + '/' + b.maxV : '') }
                doc.setTextColor(pdf.FAINT[0], pdf.FAINT[1], pdf.FAINT[2]); doc.setFontSize(7.5)
                doc.text(meta, W - 14, y + 3, { align: 'right' })
                y += 3 + titleH + 1.5

                if (cmp) {
                    const s2 = segsOf(rq2)
                    doc.setTextColor(pdf.GREEN[0], pdf.GREEN[1], pdf.GREEN[2]); doc.setFont('DejaVuSans', 'bold'); doc.setFontSize(6.5); doc.text('A', barX, y + 4)
                    if (b.total > 0) drawBar(barX + 6, y, W - 28 - 6, barH, segs); else emptyNote(barX + 6, y)
                    y += barH + 1.6
                    doc.setTextColor(59, 111, 212); doc.setFont('DejaVuSans', 'bold'); doc.setFontSize(6.5); doc.text('B', barX, y + 4)
                    if (s2.b.total > 0) drawBar(barX + 6, y, W - 28 - 6, barH, s2.segs); else emptyNote(barX + 6, y)
                    y += barH + 3
                } else {
                    if (b.total > 0) { drawBar(barX, y, W - 28, barH, segs); y += barH + 3 }
                    else { emptyNote(barX, y); y += 7 }
                }
                if (showLeg) y += drawLegend(barX, y, W - 28, legItems)
                y += 3
            })
            y += 2.5
        })

        pdf.footer(doc)
        doc.save(fileName)
    }

    generateCSV = () => {

        var rows = [];

        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props
        const isCompare = !!(this.props.compare || (filterData && filterData.compare))
        const period1 = String(moment(filterData.from1).format('LL') + ' ~ ' + moment(filterData.to1).format('LL'))
        const period2 = String(moment(filterData.from2).format('LL') + ' ~ ' + moment(filterData.to2).format('LL'))
        const emailGroup = filterData.group.map(a => a.label).join(',');
        const section = filterData.section ? filterData.section.label : '';
        const question = filterData.question ? filterData.question.label : '';
        const answer = filterData.answer.map(a => a.label).join(',');

        rows.push(['==> Filter options'])
        rows.push([t('Period1'), t('Emails Group'), t('Section'), t('Question'), t('Answers')])
        rows.push([period1, emailGroup, section, question, answer])



        const doCompare = !!(this.props.compare && this.props.surveyResponses2)
        const summaryData = this.calculateSummaryData(surveyQuestion, surveyResponses)
        const summaryData2 = doCompare ? this.calculateSummaryData(surveyQuestion, this.props.surveyResponses2) : null
        // Focus on the filter-selected section/question (same as screen/PDF).
        const focusSum = focusSelection(summaryData.reportSections, surveyQuestion, filterData)
        if (focusSum.focused) rows.push(['🔎 ' + t('Focused view'), focusSum.sectionTitle + (focusSum.questionTitle ? ' › ' + focusSum.questionTitle : '')])
        rows.push(['===> Section Average with Rating'])
        if (doCompare) {
            rows.push([t('Section'), 'A', 'B', 'Δ'])
            focusSum.sections.forEach((section, i) => {
                if (section.sectionScore === 0) return
                const origIdx = focusSum.indices[i]
                const s2 = summaryData2.reportSections[origIdx]
                const a = section.sectionScore, b = s2 ? s2.sectionScore : 0
                rows.push([`Q.${origIdx}.${section.sectionTitle}`, a.toFixed(2), b.toFixed(2), (a - b >= 0 ? '+' : '') + (a - b).toFixed(2)])
            })
        } else {
            focusSum.sections.forEach((section, i) => {
                if (section.sectionScore === 0) return
                const origIdx = focusSum.indices[i]
                const sectionLabel = `Q.${origIdx}.${section.sectionTitle}`
                const sectionScore = `${t('Score:')}  ${section.sectionScore.toFixed(2)}`
                rows.push([sectionLabel, sectionScore, ''])
            })
        }

        const surveydata = this.calculateData(surveyQuestion, surveyResponses)
        const surveydata2 = doCompare ? this.calculateData(surveyQuestion, this.props.surveyResponses2) : null
        const focusDet = focusSelection(surveydata.reportSections, surveyQuestion, filterData)
        focusDet.sections.forEach((section, i) => {
            const origIdx = focusDet.indices[i]
            const section2 = doCompare && surveydata2.reportSections[origIdx] ? surveydata2.reportSections[origIdx] : null

            section.reportQuestions.forEach((question, ekey) => {
                if (doCompare) {
                    const q2 = section2 ? (section2.reportQuestions.find(x => x.q && question.q && x.q.id === question.q.id) || null) : null
                    const map2 = {}; (q2 ? q2.reports : []).forEach(r => { map2[r.answer] = r })
                    const questionTitle = question.questionTitle +
                        (question.questionScore > 0 ? "  A:" + question.questionScore.toFixed(2) : '') +
                        (q2 && q2.questionScore > 0 ? "  B:" + q2.questionScore.toFixed(2) : '')
                    rows.push([`===> ${questionTitle}`])
                    rows.push([t('Answer'), 'A ' + t('Answer'), 'A %', 'B ' + t('Answer'), 'B %'])
                    question.reports.forEach((item) => {
                        const m = map2[item.answer]
                        rows.push([item.answerLabel, item.count, item.percent.toFixed(2) + '%', m ? m.count : 0, m ? m.percent.toFixed(2) + '%' : '0%'])
                    })
                } else {
                    const questionTitle = question.questionTitle + (question.questionScore > 0 ? " " + t('Score:') + " " + question.questionScore.toFixed(2) : '')
                    rows.push([`===> ${questionTitle}`])
                    rows.push([t('Activity'), t('Answer'), t('Relative Answers')])
                    question.reports.forEach((item) => {
                        rows.push([item.answerLabel, item.count, item.percent.toFixed(2) + '%'])
                    })
                }
            })

        });


        let csvContent = "data:text/csv;charset=utf-8,"
            + rows.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        window.open(encodedUri);
    }

    // Excel export of the Analytical view — same content as the on-screen report, with numeric
    // scores/counts/percentages as real numbers so they can be summed and charted in Excel.
    generateExcel = (fileName) => {
        const { filterData, surveyQuestion, surveyResponses } = this.props
        const isCompare = !!(this.props.compare || (filterData && filterData.compare))
        const period1 = String(moment(filterData.from1).format('LL') + ' ~ ' + moment(filterData.to1).format('LL'))
        const period2 = String(moment(filterData.from2).format('LL') + ' ~ ' + moment(filterData.to2).format('LL'))
        const rows = []
        rows.push([t('Report Type'), 'Analytical'])
        rows.push([t('Period1'), period1])
        if (isCompare) rows.push([t('Period2'), period2])
        rows.push([t('Emails Group'), filterData.group.map(a => a.label).join(', ')])
        rows.push([t('Section'), filterData.section ? filterData.section.label : ''])
        rows.push([t('Question'), filterData.question ? filterData.question.label : ''])
        rows.push([t('Answers'), filterData.answer.map(a => a.label).join(', ')])
        rows.push([t('Total Answers'), surveyResponses.length])
        rows.push([])

        const doCompare = !!(this.props.compare && this.props.surveyResponses2)
        const summaryData = this.calculateSummaryData(surveyQuestion, surveyResponses)
        const summaryData2 = doCompare ? this.calculateSummaryData(surveyQuestion, this.props.surveyResponses2) : null
        // Focus on the filter-selected section/question (same as screen/PDF).
        const focusSum = focusSelection(summaryData.reportSections, surveyQuestion, filterData)
        if (focusSum.focused) { rows.push(['🔎 ' + t('Focused view'), focusSum.sectionTitle + (focusSum.questionTitle ? ' › ' + focusSum.questionTitle : '')]); rows.push([]) }
        if (doCompare) {
            rows.push([t('Section Average with Rating'), 'A', 'B', 'Δ'])
            focusSum.sections.forEach((section, i) => {
                if (section.sectionScore > 0) {
                    const s2 = summaryData2.reportSections[focusSum.indices[i]]
                    const a = section.sectionScore, b = s2 ? s2.sectionScore : 0
                    rows.push([section.sectionTitle, Number(a.toFixed(2)), Number(b.toFixed(2)), Number((a - b).toFixed(2))])
                }
            })
        } else {
            rows.push([t('Section Average with Rating'), Number(summaryData.surveyScore.toFixed(2))])
            focusSum.sections.forEach(section => {
                if (section.sectionScore > 0) rows.push([section.sectionTitle, Number(section.sectionScore.toFixed(2))])
            })
        }
        rows.push([])

        const surveydata = this.calculateData(surveyQuestion, surveyResponses)
        const surveydata2 = doCompare ? this.calculateData(surveyQuestion, this.props.surveyResponses2) : null
        const focusDet = focusSelection(surveydata.reportSections, surveyQuestion, filterData)
        focusDet.sections.forEach((section, i) => {
            const section2 = doCompare && surveydata2.reportSections[focusDet.indices[i]] ? surveydata2.reportSections[focusDet.indices[i]] : null
            rows.push([])
            if (doCompare) {
                const a = section.sectionScore, b = section2 ? section2.sectionScore : 0
                rows.push([section.sectionTitle, 'A', a > 0 ? Number(a.toFixed(2)) : '', 'B', b > 0 ? Number(b.toFixed(2)) : ''])
            } else {
                rows.push([section.sectionTitle, t('Score'), section.sectionScore > 0 ? Number(section.sectionScore.toFixed(2)) : ''])
            }
            section.reportQuestions.forEach((question, ekey) => {
                if (doCompare) {
                    const q2 = section2 ? (section2.reportQuestions.find(x => x.q && question.q && x.q.id === question.q.id) || null) : null
                    const map2 = {}; (q2 ? q2.reports : []).forEach(r => { map2[r.answer] = r })
                    rows.push([question.questionTitle, 'A ' + t('Score'), question.questionScore > 0 ? Number(question.questionScore.toFixed(2)) : '', 'B ' + t('Score'), q2 && q2.questionScore > 0 ? Number(q2.questionScore.toFixed(2)) : ''])
                    rows.push([t('Answer'), 'A ' + t('Answers'), 'A %', 'B ' + t('Answers'), 'B %'])
                    question.reports.forEach(item => {
                        const m = map2[item.answer]
                        rows.push([item.answerLabel, item.count, Number(item.percent.toFixed(2)), m ? m.count : 0, m ? Number(m.percent.toFixed(2)) : 0])
                    })
                } else {
                    rows.push([question.questionTitle, t('Score'), question.questionScore > 0 ? Number(question.questionScore.toFixed(2)) : ''])
                    rows.push([t('Answer'), t('Answers'), t('Relative Answer')])
                    question.reports.forEach(item => rows.push([item.answerLabel, item.count, Number(item.percent.toFixed(2))]))
                }
            })
        })
        downloadXlsx([{ name: 'Analytical', rows }], fileName)
    }
    getEmailsFromGroup = (group) => {

        const emaillist = this.state.emaillist
        var emails = [];
        emaillist.forEach(elist => {
            const existIndex = group.findIndex(g => g.value === elist.id)
            if (existIndex > -1) {
                const elist_emails = elist.emails.map(e => e.email)
                emails = emails.concat(elist_emails)
            }
        });
        return emails;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.time !== this.props.time) {
            this.initData()
        }
    }

    calculateData = (filterQuestion, filterResponses) => {
        let reportSections = [];
        let surveyScore = 0
        let totalResult = null
        if (filterQuestion.sections.length > 0) {

            let countSectionScore = 0
            filterQuestion.sections.map((section) => {
                let reportQuestions = []
                let sectionScore = 0
                if (section.questions.length > 0) {
                    let countQuestionScore = 0
                    section.questions.map((q) => {
                        if (Score.SKIPTYPES.indexOf(q.question.type) >= 0) return null;
                        const reportOfQuestion = Score.getReportOfQuestion(q, filterResponses);
                        reportOfQuestion.q = q;
                        reportQuestions.push(reportOfQuestion)
                        if (reportOfQuestion.questionScore > 0) {
                            countQuestionScore++;
                            sectionScore += reportOfQuestion.questionScore
                        }
                    })
                    sectionScore = countQuestionScore > 0 ? (sectionScore / countQuestionScore) : 0
                }
                const reportsForSection = {
                    sectionTitle: section.sectionTitle,
                    reportQuestions,
                    sectionScore
                }
                reportSections.push(reportsForSection)
                if (reportsForSection.sectionScore > 0) {
                    countSectionScore++
                    surveyScore += reportsForSection.sectionScore
                }
            })
            totalResult = {
                reportSections: reportSections,
                surveyScore: countSectionScore > 0 ? (surveyScore / countSectionScore) : 0
            }
        }
        return totalResult
    }
    // Banner shown when the report is focused on a filter-selected section/question, so the user
    // knows the view is intentionally narrowed (and how to widen it again).
    renderFocusBanner = () => {
        const fd = this.props.filterData
        if (!fd || !fd.section) return null
        const secT = fd.section.label
        const qT = fd.question ? fd.question.label : null
        return <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', background: '#eef7f1', border: '1px solid #cfe6d7', borderRadius: 10, padding: '9px 14px', margin: '0 2px 14px', fontSize: 13, color: '#2f6b4f' }}>
            <span>🔎</span>
            <span><b>{t('Focused view')}:</b> {secT}{qT ? ' › ' + qT : ''} — {t('showing only your filtered selection')}.</span>
            <span style={{ color: '#8a988f' }}>{t('Clear the section filter to see all sections.')}</span>
        </div>
    }

    renderAnalytics = (data, data2, compare) => {
        if (!data) return null
        const cardStyle = { background: '#fff', border: '1px solid #e2e8e4', borderRadius: 14, boxShadow: '0 1px 2px rgba(20,40,30,.06),0 6px 20px rgba(20,40,30,.05)', marginBottom: 16, overflow: 'hidden' }
        const cardHeadStyle = { padding: '14px 18px', borderBottom: '1px solid #e2e8e4', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }
        const focus = focusSelection(data.reportSections, this.props.surveyQuestion, this.props.filterData)
        return focus.sections.map((section, skey) => {
            const origIdx = focus.indices[skey]
            // a section's scale = the widest rating scale among its questions (for the chip denominator)
            let secScale = 5
            section.reportQuestions.forEach(rq => { if (rq.q && rq.q.question && rq.q.question.type === 'radio') { const mv = ratingBuckets(rq.q, rq.reports).maxV; if (mv > secScale) secScale = mv } })
            const section2 = (compare && data2 && data2.reportSections[origIdx]) ? data2.reportSections[origIdx] : null
            return <div style={cardStyle} key={skey}>
                <div style={cardHeadStyle}>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{section.sectionTitle}</div>
                    {section.sectionScore > 0 && (
                        (compare && section2 && section2.sectionScore > 0)
                            ? <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <ScoreChip score={section.sectionScore} scale={secScale} />
                                {deltaText(section.sectionScore, section2.sectionScore)}
                            </div>
                            : <ScoreChip score={section.sectionScore} scale={secScale} />
                    )}
                </div>
                <div style={{ padding: '4px 18px 12px' }}>
                    {section.reportQuestions.map((rq, ekey) => {
                        const b = ratingBuckets(rq.q, rq.reports)
                        const borderBottom = ekey < section.reportQuestions.length - 1 ? '1px solid #eef2f0' : 'none'
                        const rq2 = section2 ? (section2.reportQuestions.find(x => x.q && rq.q && x.q.id === rq.q.id) || null) : null
                        if (compare && rq2) {
                            const a = rq.questionScore, bb = rq2.questionScore
                            const showScores = b.rating && (a > 0 || bb > 0)
                            const meta = showScores ? ('A ' + a.toFixed(2) + ' · B ' + bb.toFixed(2)) : ('n=' + b.total)
                            return <div key={ekey} style={{ padding: '12px 0', borderBottom }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, marginBottom: 7 }}>
                                    <div style={{ fontSize: 14, fontWeight: 600 }}>{rq.questionTitle}</div>
                                    <div style={{ fontSize: 12, color: '#8a988f', fontFamily: MONO, whiteSpace: 'nowrap' }}>
                                        {meta}{showScores ? deltaText(a, bb) : null}
                                    </div>
                                </div>
                                <CompareBars question={rq.q} reportsA={rq.reports} reportsB={rq2.reports} />
                                <RatingLegend question={rq.q} reports={rq.reports} />
                            </div>
                        }
                        const pos = positivePercent(rq.q, rq.reports)
                        // Respondents who never answered this question (skipped/unticked/never saw it) —
                        // said out loud, so "n" below the period's response total reads as what it is.
                        const unanswered = rq.totalResponses != null ? rq.totalResponses - rq.answeredCount : 0
                        const meta = [
                            'n=' + b.total,
                            unanswered > 0 ? unanswered + ' ' + t('without answer') : null,
                            pos != null ? pos + '% ' + t('positive') : null,
                            b.rating && rq.questionScore > 0 ? rq.questionScore.toFixed(2) + '/' + b.maxV : null,
                        ].filter(Boolean).join(' · ')
                        return <div key={ekey} style={{ padding: '12px 0', borderBottom }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, marginBottom: 7 }}>
                                <div style={{ fontSize: 14, fontWeight: 600 }}>{rq.questionTitle}</div>
                                <div style={{ fontSize: 12, color: '#8a988f', fontFamily: MONO, whiteSpace: 'nowrap' }}>{meta}</div>
                            </div>
                            <DistributionBar question={rq.q} reports={rq.reports} />
                            <RatingLegend question={rq.q} reports={rq.reports} />
                        </div>
                    })}
                </div>
            </div>
        })
    }

    render() {
        const { reportData, reportData2, compare } = this.state
        if (!reportData) return '...'
        return <div>
            {this.renderFocusBanner()}
            {compare && reportData2 &&
                <div style={{ display: 'flex', gap: 16, fontSize: 12, color: '#5d6d66', margin: '2px 2px 14px' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><i style={{ width: 11, height: 11, borderRadius: 3, background: '#2f9e44', display: 'inline-block' }} />{t('Period')} A</span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><i style={{ width: 11, height: 11, borderRadius: 3, background: '#3b6fd4', display: 'inline-block' }} />{t('Period')} B</span>
                    <span style={{ color: '#8a988f' }}>Δ = A − B</span>
                </div>
            }
            {this.renderAnalytics(reportData, reportData2, compare)}
        </div>;
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withTranslation()(withStyles(styles, { withTheme: true })(Analytical))
);